// extracted by mini-css-extract-plugin
export var childrenContainer = "_di-0";
export var virtualScrollArea = "_di-1";